import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'flamingo-confirm-dialog',
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    
    <mat-dialog-content fxLayout="column">
      <p>{{ data.description }}</p>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <ng-container *ngIf="!!data.cancel">
        <button mat-button [mat-dialog-close]="undefined" cdkFocusInitial class="btn-margin">
          <span>{{ data.cancel }}</span>
        </button>
      </ng-container>
      
      <button mat-button [mat-dialog-close]="true" color="accent" class="btn-margin">
        <span>{{ data.confirm }}</span>
      </button>
    </mat-dialog-actions>
  `,
})
export class FlamingoConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FlamingoConfirmDialogModel>,
    @Inject(MAT_DIALOG_DATA) public data: FlamingoConfirmDialogModel,
  ) {
  }

  close(res: boolean): void {
    this.dialogRef.close(res);
  }
}

export interface FlamingoConfirmDialogModel {
  title: string;
  description: string;
  confirm: string;
  cancel: string;
}
